import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-897ed28c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "contact-us"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "arrow-top bak"
}, null, -1));
const _hoisted_3 = [_hoisted_2];
import { onMounted, ref, onUnmounted } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'contact-us',
  setup(__props) {
    const show = ref(false);
    onMounted(() => {
      window.addEventListener('scroll', scrollEvent);
    });
    onUnmounted(() => {
      window.removeEventListener('scroll', scrollEvent);
    });
    const scrollEvent = () => {
      const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      const h = 1000;
      if (scrollTop > h) {
        show.value = true;
      } else {
        show.value = false;
      }
    };
    const clickGoTopBtn = () => {
      window.scrollTo(0, 0);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", {
        id: "goto-top",
        class: "goto-top",
        onClick: clickGoTopBtn
      }, _hoisted_3, 512), [[_vShow, show.value]])]);
    };
  }
});